<!--<script src="../../../../../life_driving_school/babel.config.js"></script>-->
<template>
  <bv-home-view :router-level="3" style="background-color: #fff">
    <div style="padding-bottom: 12vh">
      <!--页面顶部-->
      <div class="shade-bg bc-pd-b-20rp" :style="`background-image:url(${staticPath}/bg${file})`">
        <!--返回-->
        <div class="bc-row bc-pd-10rp">
          <div class="bc-fl-l">
            <i class="icon icon icon-left bc-f-16rp bc-t-white bc-f-b" @click="goBack()"></i>
          </div>
          <div
            class="bc-fl-r bc-pd-r-6rp appshare"
            v-if="config.device.isApp"
            @click="
              $share({
                title: '慧联天下区域代理项目说明',
                descr: '--来自慧联天下综合服务平台',
                thumImage: `${programUrl['gou-wu-bao']}/Static/public/images/shareImg.png`,
              })
            "
          >
            <i class="icon icon-share bc-f-16rp bc-t-white bc-f-b"></i>
          </div>
        </div>
        <!--banner-->
        <div class="bc-row">
          <div class="bc-w-70" style="margin: auto">
            <img :src="`${staticPath}/title.png`" class="bc-block bc-w-100" alt="" />
          </div>
        </div>
        <!--滚动提示-->
        <div class="bc-row bc-pd-tb-38rp">
          <div class="bc-w-70 bc-ps-r bc-bd-radius-20 bc-pd-4rp autoWiper" style="margin: auto">
            <bv-swiper-scroll class="bc-row bc-ps-a creator-tips" :current-index="currentScrollIndex" direction="y">
              <template slot="scroll-items">
                <div v-for="item in autoData" class="bc-t-hide">
                  <div class="bc-flex bc-flex-jc-sb bc-flex-ai-c">
                    <div class="bc-flex-1">
                      <div class="bc-overflow-hide wiperHeaderImg">
                        <img :src="item.head_img" class="bc-block bc-w-100" alt="" />
                      </div>
                    </div>
                    <div class="bc-flex-3 bc-t-hide">{{ item.nickname }}</div>
                    <div class="bc-flex-3 bc-t-c">已入驻区域代理</div>
                  </div>
                </div>
              </template>
            </bv-swiper-scroll>
          </div>
          <div class="bc-pd-tb-24rp"></div>
        </div>

        <!--提示-->
        <!-- <div class="">
          <div class="bc-pd-t-10rp bc-pd-lr-16rp bc-pd-b-32rp bc-ps-r bc-bd-radius-8 bc-w-88 bc-bg-white tip">
            <div class="bc-f-18rp bc-pd-tb-20rp" style="text-indent: 2em; color: #845e2e">
              <div class="bc-mg-b-2rp">本资料专为正在寻找项目的您所编写，机遇就在字里行间，请您仔细、认真阅读。</div>
              <div>同时您也可以联系平台客服为您答疑解惑，欢迎您的来电！</div>
            </div>
            <div class="bc-flex bc-flex-ai-c bc-flex-jc-sb bc-mg-lr-4rp bc-bd-radius-8 bc-f-18rp bc-overflow-hide telCall">
              <div class="bc-t-white bc-pd-tb-4rp bc-pd-lr-6rp bc-flex-3">项目咨询</div>
              <div class="bc-t-c bc-pd-4rp bc-flex-6" style="background: #fff; color: #ff8932"><span>400</span><span> 684 </span><span>3688</span></div>
              <div class="bc-flex-2 bc-t-c">
                <a href="javascript:;" class="bc-block bc-pd-4rp call_phone" @click.stop="callPhone($event, '4006843688')">
                  <i class="icon icon-dianhua bc-t-white bc-f-18rp"></i>
                </a>
              </div>
            </div>
          </div>
        </div> -->
      </div>

      <!-- 项目介绍 -->
      <!-- <div>
        <div class="bc-ps-r" id="one">
          <img :src="`${staticPath}/project${file}`" class="bc-block bc-w-100" alt="" />
          <div class="bc-pd-lr-16rp bc-ps-a bc-w-100; bc-flex bc-flex-jc-c bc-flex-ai-c bc-w-100" style="bottom: 0; left: 0; height: 50%">
            <audio v-if="mediaData.length > 0 && mediaData[0].src != null" class="bc-block bc-w-100" style="outline: none" ref="my_audio" controls controlslist="nodownload" @play="isPlay = true" @pause="isPlay = false" :src="mediaData[0].src" :alt="mediaData[0].title"></audio>
          </div>
        </div>
      </div>

      <img v-for="i in 3" :key="i" :src="`${staticPath}/${i}${file}`" :id="i === 3 ? 'two' : null" class="bc-block bc-w-100" alt="" />
      <video
        v-if="mediaData.length > 0 && mediaData[1].src != null"
        :src="mediaData[1].src"
        :alt="mediaData[1].title"
        :id="mediaData[1].id"
        :poster="`${staticPath}/video_cover.png`"
        class="bc-block bc-w-100"
        controls
        x5-playsinline
        x-webkit-airplay
        playsinline
        webkit-playsinline
        preload="preload"
      ></video>

      <img v-for="i in 10" :key="i + 3" :src="`${staticPath}/${i + 3}${file}`" :id="i + 3 === 7 ? 'three' : i + 3 === 13 ? 'four' : null" class="bc-block bc-w-100" alt="" /> -->
    </div>

    <template slot="other" slot-scope="scope">
      <!--底部按钮-->
      <div class="bc-row bc-ps-f bc-v-t bc-t-c bc-pd-b-6rp bottom-btn" style="bottom: 0; left: 0; z-index: 1000">
        <!-- 登录了 -->
        <template v-if="$store.getters.isLogin">
          <template v-if="notPass">
            <router-link :to="`/join/agent-apply?id=${errorData.id}&share=${$route.query.share}&lv=2`"> 重新申请 </router-link>
          </template>
          <template v-else>
            <router-link :to="`/join/agent-apply?share=${$route.query.share}&lv=2`">
              <!-- 已经是创客 -->
              申请加入区域代理
            </router-link>
          </template>
        </template>
        <!--没有登录-->
        <template v-else>
          <a @click="$login"> 申请加入区域代理 </a>
        </template>
      </div>
      <!--顶部按钮-->
      <transition name="fade">
        <div class="bc-ps-f bc-w-100 bc-pd-tb-16rp bc-pd-lr-3rp bc-f-16rp bc-t-white bc-flex bc-flex-jc-sb bc-flex-ai-c topBtn bc-t-c" style="background: rgba(0, 0, 0, 0.8)" v-show="scope.scroll.top > topHeight[0]">
          <div class="bc-flex-1 bc-pd-lr-3rp" v-for="(item, index) in buttonMsg" :key="index">
            <div @click="changeBtn(index)" class="bc-pd-tb-3rp bc-pd-lr-6rp btnAll" :class="buttonIndex === index ? 'active' : ''">{{ item }}</div>
          </div>
        </div>
      </transition>
      <!--音频按钮-->
      <!--<div class="bc-ps-f power">-->
      <!--<div class="powerImg" @click="playerPower">-->
      <!--<img :src="`${staticPath}/${isPlay ? 'powerON' : 'powerOFF'}.jpg`" class="bc-block bc-w-100" alt="">-->
      <!--</div>-->
      <!--</div>-->
      <!-- 审核不通过 -->
      <mt-popup v-model="popupFlag" :modal="true" :closeOnClickModal="false" pop-transition="popup-fade" position="center">
        <div class="bc-bd-radius-10 bc-overflow-hid" style="width: 75vw; background: #f8fcff">
          <div>
            <img :src="`${staticPath}/error.png`" class="bc-block bc-w-100 bc-bd-radius-10" alt="" />
          </div>
          <div class="bc-pd-lr-40rp bc-f-16rp bc-w-100" style="word-wrap: break-word; word-break: break-all; overflow: hidden; line-height: 1.6em">
            <div class="bc-w-100 bc-t-333">
              申请类型：<span class="bc-t-666">{{ errorData.area_type }}</span>
            </div>
            <div class="bc-w-100 bc-t-333">
              申请区域：<span class="bc-t-666">{{ errorData.area }}</span>
            </div>
            <div class="bc-w-100 bc-t-333">
              不通过原因：<span class="bc-t-666">{{ errorData.why }}</span>
            </div>
            <div class="bc-w-100 bc-t-333">
              如有疑问,请致电:
              <div><a href="javascript:;" class="call_phone" style="color: #edc16b" @click.stop="callPhone($event, '400-6843-688')">400-6843-688</a></div>
            </div>
            <div class="bc-flex bc-flex-ai-c bc-flex-jc-sb bc-pd-tb-16rp bc-t-white">
              <div class="bc-pd-tb-4rp bc-pd-lr-10rp bc-bd-radius-6" style="background: #c4c4c4" @click="popupFlag = false">我知道了</div>
              <div class="bc-pd-tb-4rp bc-pd-lr-10rp bc-bd-radius-6" style="background: #edc16b">
                <router-link :to="`/join/agent-apply?id=${errorData.id}&share=${$route.query.share}&lv=2`" class="bc-t-white"> 重新申请 </router-link>
              </div>
            </div>
          </div>
        </div>
      </mt-popup>
    </template>
  </bv-home-view>
</template>

<script>
import { keepScroll } from "$assets/js/keep-alive-scroll.js";
import programUrl from "@config/program-url";
import { Popup } from "mint-ui";

export default {
  name: "agent-city",
  mixins: [keepScroll()],
  components: {
    Popup,
  },
  data() {
    const self = this;
    return {
      file: ".png",
      programUrl: programUrl,
      timer: 0,
      autoData: [],
      errorData: {
        id: 0,
        area_type: "",
        area: "",
        why: "",
      },
      currentScrollIndex: 0,
      buttonMsg: ["时代趋势", "项目背书", "项目优势", "加盟条件"],
      buttonIndex: 0, // 按钮的当前索引
      topHeight: [0, 0, 0, 0],
      isPlay: false, // 播放开关
      mediaData: [], // 媒体数据
      swiperData: [],
      popupFlag: false,
      //				轮播
      activeIndex: 0,
      swiperOption: {
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        loop: false,
        autoplay: false,
        centeredSlides: true,
        spaceBetween: 30,
        slidesPerView: 3,
        centeredSlides: true,
        //手势滑动过以后，依然能够重启轮播
        autoplay: {
          disableOnInteraction: false,
        },
        //          当slides的总数小于slidesPerView时，slides居中
        centerInsufficientSlides: true,
        on: {
          slideChangeTransitionStart: function() {
            self.activeIndex = this.activeIndex;
          },
        },
      },
      playVideoId: 0, //当前播放视频的id
      videoList: [],
      notPass: false,
    };
  },
  computed: {
    staticPath() {
      return `${this.config.path.static}/img/home/join/agent/city`;
    },
    swiper() {
      return this.$refs.swiperOne.$swiper;
    },
  },
  methods: {
    playVideo() {
      this.videoList = document.getElementsByTagName("video");
      for (let i = 0; i < this.videoList.length; i++) {
        this.videoList[i].addEventListener("play", ele => {
          this.playVideoId = ele.target.getAttribute("id");
        });
      }
    },

    // 自动轮播入驻代理信息
    auto() {
      this.timer = setTimeout(() => {
        if (this.currentScrollIndex === this.autoData.length - 1) {
          this.currentScrollIndex = 0;
        } else {
          ++this.currentScrollIndex;
        }
        this.auto();
      }, 2000);
    },
    async getData() {
      const { data } = await this.$axios.get("/member/area_apply/main?level=2");
      this.autoData = data.data.areas;
      if (this.autoData.length > 0) {
        this.auto();
      }
      if (data.data.area_info.id) {
        this.errorData = data.data.area_info;
      }
      if (this.errorData.area_type.indexOf("县") != -1) return false; // 别跑错片场了
      if (data.data.area_info.audit == -1 || data.data.area_info.audit == 3) {
        this.notPass = true;
        this.popupFlag = true;
      }
    },

    // 按钮点击切换
    changeBtn(index) {
      this.buttonIndex = index;
      // console.log(this.buttonIndex, "55");
      document.querySelectorAll(".bv-view-scroll")[2].scrollTo({
        top: this.topHeight[index] - 10,
        behavior: "instant",
      });
    },
    // 音频开关
    playerPower() {
      if (this.isPlay) {
        // 暂停
        this.$refs.my_audio.pause();
      } else {
        // 播放
        this.$refs.my_audio.play();
      }
      this.isPlay = !this.isPlay;
    },

    async getInitData() {
      const { data } = await this.$axios.get("/api/video/area_video_list?type=1");
      data.data.data.video.forEach(item => {
        this.mediaData.push({
          position: item.position,
          title: item.title,
          type: item.content[0].type,
          src: item.content[0].PlayURL,
          cover: item.cover_img,
          id: item.id,
        });
      });
      this.swiperData = data.data.data.image;

      this.$nextTick(() => {
        setTimeout(() => {
          this.topHeight[0] = document.querySelector("#one").offsetTop;
          this.topHeight[1] = document.querySelector("#two").offsetTop - 50;
          this.topHeight[2] = document.querySelector("#three").offsetTop - 50;
          this.topHeight[3] = document.querySelector("#four").offsetTop - 50;
        }, 1000);

        let that = this;
        document.querySelectorAll(".bv-view-scroll")[2].addEventListener("scroll", function() {
          if (this.scrollTop > that.topHeight[3] - 51) {
            that.buttonIndex = 3;
          } else if (this.scrollTop > that.topHeight[2] - 51) {
            that.buttonIndex = 2;
          } else if (this.scrollTop > that.topHeight[1] - 51) {
            that.buttonIndex = 1;
          } else {
            that.buttonIndex = 0;
          }
        });
      });
    },
    // 打电话
    callPhone(e, tel) {
      const ua = navigator.userAgent.toLowerCase();
      const ios = ua.match(/cpu iphone os (.*?) like mac os/);
      if (this.config.device.isApp && ios) {
        dtb.callCustomer(tel);
      } else {
        e.currentTarget.setAttribute("href", `tel:${tel}`);
      }
    },
    goBack() {
      if (window.history.length > 1) history.back();
      else location.replace(`${programUrl["cai-fu-bao"]}`);
    },
  },
  updated() {},
  beforeDestroy() {
    clearTimeout(this.timer);
    // 暂停音频
    this.$refs.my_audio.pause();
    this.isPlay = false;
  },
  activated() {
    this.getData();
    this.getInitData();

    let endCode = encodeURIComponent(programUrl["gou-wu-bao"] + "/home/index/home");
    let centerCode = encodeURIComponent("/#/join/agent-city");

    this.$weChatShare({
      title: "慧联天下区域代理项目说明",
      desc: "--来自慧联天下综合服务平台",
      imgUrl: `${programUrl["gou-wu-bao"]}/Static/public/images/shareImg.png`,
      link() {
        return programUrl["gou-wu-bao"] + "/common/autoreg?redirect_url=" + centerCode + "&want_url=" + endCode;
      },
    });

    setTimeout(() => {
      this.playVideo();
    }, 0);
  },
  watch: {
    //      '$refs.swiperOne.swiper.activeIndex'(value){
    //        console.log(value)
    //			},
    playVideoId(newVal) {
      for (let i = 0; i < this.videoList.length; i++) {
        if (this.videoList[i].getAttribute("id") != newVal) {
          this.videoList[i].pause();
          this.$refs.my_audio.pause();
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
/*顶部bar动画*/
.fade-enter,
.fade-leave-to {
  opacity: 0;
  transform: translateY(-100px);
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.5s ease;
  /*position: absolute;*/
}

.shade-bg {
  // background: linear-gradient(45deg, rgba(85, 159, 241, 1), rgba(50, 131, 222, 1));
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.autoWiper {
  background: rgba($color: #ffaf25, $alpha: 0.5);
  color: #333333;
  .creator-tips {
    top: 0;
    left: 50%;
    width: 100%;
    height: rem(28);
    /*line-height: rem(28);*/
    transform: translateX(-50%);
  }

  .wiperHeaderImg {
    width: rem(28);
    height: rem(28);
    border-radius: 50%;
  }
}

.tip {
  margin: rem(-66) auto 0;
  box-shadow: 0 10px 50px 0 rgba(93, 156, 214, 0.2);

  .telCall {
    background: #ff8932;
    border: 1px solid #ff8932;
  }

  .robot {
    top: 0;
    left: 0;
    width: rem(82);
    height: rem(82);
    transform: translate(-22%, -15%);
  }
}

.btnAll {
  border: 1px solid #edc16b;
  border-radius: rem(40);
}

.active {
  background: #edc16b;
  color: #62450d;
  box-shadow: 0 3px 0 #b97b01;
  font-weight: bold;
}

.topBtn {
  top: 0;
  left: 0;
  z-index: 100;
}

.bottom-btn {
  a {
    box-shadow: 0 2px 16px rgba(0, 0, 0, 0.2);
    display: inline-block;
    color: white;
    width: 92%;
    font-weight: bold;
    letter-spacing: 2px;
    background: #edc16b;
    -webkit-border-radius: 30px;
    -moz-border-radius: 30px;
    border-radius: 30px;
    padding: rem(12) 0;
    font-size: rem(18);
  }
}

.power {
  top: 75%;
  right: 0;
  z-index: 200;

  .powerImg {
    width: rem(80);
  }
}

.mint-popup-center {
  background: transparent;
}

.bv-view .no-tab-bar {
  background: transparent !important;
}

/* 轮播 */
/*.swiper-one /deep/ .swiper-pagination-bullet {
		background: #cee4fc;
	}*/
.swiper-one /deep/ .swiper-slide {
  transform: scale(0.8) !important;
}
.swiper-one /deep/ .swiper-slide-active {
  transform: scale(1.3) !important;
}
.swiper-one /deep/ .swiper-container,
.swiper-wrapper {
  width: 100%;
  text-align: center;
  overflow: visible;
}
.swiper-one /deep/ .swiper-pagination-bullet-active {
  width: rem(15);
  height: rem(8);
  background: #7db6f7;
  opacity: 0.8;
  border-radius: 8px;
}
.swiper-one /deep/ .swiper-pagination-bullets {
  bottom: rem(-25);
}
.swiper-one /deep/ .swiper-title {
  color: #15265b;
  height: rem(64) !important;
}
.swiper-one /deep/ .swiper-slide-active {
}
</style>
